import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { APP_CONFIGURATION_TOKEN } from '../core';


/**
 * This service handles help modal component.
 */
@Injectable({ providedIn: 'root' })
export class HelpService {

	private readonly http = inject(HttpClient);
	private readonly sanitizer = inject(DomSanitizer);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);

	private _fileNameList: any = null;
	private _isLoaded: boolean = false;
	private _lang?: string;

	private readonly _baseUrl: string = this.configs.helpSite.baseUrl;
	private readonly _fileNames: string = this.configs.helpSite.fileNames;

	/**
	 * Check if help file name list is loaded.
	 */
	get isLoaded(): boolean {
		return this._isLoaded;
	}

	/**
	 * Load help file name list.
	 */
	loadFileNames(lang: string): Observable<any> {
		return this.http.get(this._fileNames).pipe(
			tap(list => {
				this._lang = lang;
				this._fileNameList = list;
				this._isLoaded = true;
			})
		);
	}

	/**
	 * Get safe url of help.
	 */
	get safeUrl(): SafeUrl | null {
		const url = this._helpUrl;
		return url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
	}

	private get _helpUrl(): string | null {
		const fileName = this._fileNameList?.[this._fileKey] ?? null;
		return fileName ? `${this._baseUrl}/${this._lang}/${fileName}.html` : null;
	}

	private get _fileKey(): string {
		const pathName = window.location.pathname;
		switch (pathName) {
			case '/dashboard': return 'DASHBOARD';
			case '/list': return 'PATIENT_LIST';
			case '/patient/edit': return 'PATIENT_SETTINGS';
			case '/patient/history': return 'PATIENT_HISTORY';
			case '/plan/edit': return 'PLAN_SETTINGS';
			case '/publish': return 'PUBLISH';
			default: return '';
		}
	}
}
